import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/dashboard')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      checkOnboarding: Boolean(search.checkOnboarding) ? true : undefined,
    };
  },
});
